export interface RootState {
  signalRBulbColor: string;
  doesEmailConfigurationsExist: boolean;
  isCustomDomainAdded: boolean;
  isSignalRConnected: boolean;
  isAccountNotExist: boolean;
  serviceProviderId: number;
  serviceProviderName: string;
  serviceProviderPhone: string;
  supportEmail: string;
}

export const StoreState = {
  signalRBulbColor: "",
  doesEmailConfigurationsExist: false,
  isCustomDomainAdded: false,
  isSignalRConnected: false,
  isAccountNotExist: false,
  serviceProviderId: 0,
  serviceProviderName: "",
  serviceProviderPhone: "",
  supportEmail: "",
} satisfies RootState;
